(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("locale/locale_ar", [], factory);
	else if(typeof exports === 'object')
		exports["locale/locale_ar"] = factory();
	else
		root["locale/locale_ar"] = factory();
})(window, function() {
return 